import { render } from "./DispatcherWorkplace.vue?vue&type=template&id=41932a1a&ts=true"
import script from "./DispatcherWorkplace.vue?vue&type=script&lang=ts"
export * from "./DispatcherWorkplace.vue?vue&type=script&lang=ts"

import "./DispatcherWorkplace.vue?vue&type=style&index=0&id=41932a1a&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__